import { useQuery, UseQueryResult } from 'react-query';
import type { KiloClassListView } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

function useKiloClassesByTypeAndDate({
  kiloClassTypeId,
  date,
}: {
  kiloClassTypeId: string | undefined;
  date: string | undefined;
}): UseQueryResult<{ data: KiloClassListView[] }> {
  return useQuery(
    ['classes', 'by-type-and-date', kiloClassTypeId, date],
    () =>
      client.get(
        `kilo-classes/?${encodeUrlParams({
          start: date as string,
          end: date as string,
          kilo_class_type: kiloClassTypeId as string,
          // The list endpoint returns the recurring root template + occurrences
          // by default; this filter drops the root so callers get only instances.
          exclude_root: 'true',
        })}`,
      ),
    { enabled: !!kiloClassTypeId && !!date },
  );
}

export default useKiloClassesByTypeAndDate;
